import * as __au2ViewDef from './abn-lookup.html';
import { FieldValidationRenderer } from './../../../common/validation-renderers/field-validation-renderer';
import { AbnSelectedPropertyRule } from './../../../common/validation-matchers/is-abn-selected';
import { objectIsValid } from './../../../common/functions/object-is-valid';
import { newInstanceForScope } from '@aurelia/kernel';
import { IValidationController } from '@aurelia/validation-html';
import { AbnNameSelectedPropertyRule } from './../../../common/validation-matchers/is-abn-name-selected';
import { AbnNumberSelectedPropertyRule } from './../../../common/validation-matchers/is-abn-number-selected';
import { bindable, customElement, INode, IEventAggregator } from 'aurelia';
import { watch } from '@aurelia/runtime-html';
import { IApiService } from '../../../services/api';

import { INotification } from 'aurelia2-notification';
import { IValidationRules } from '@aurelia/validation';

/* eslint-disable @typescript-eslint/no-empty-function */

@customElement({ ...__au2ViewDef, name: 'abn-lookup' })
export class AbnLookup {
    @bindable passedAbn = {};
    @bindable placeholder = 'search by abn or name';
    @bindable callback: any = () => { };
    @bindable visibilityCondition = true;
    @bindable stepName;
    @bindable resetOnChange = false;
    userFieldValue = '';

    public buttonDisabled = true;
    public manuallySelected = false;
    public showSearch = false;
    public error = null;
    public selectedResult = {};
    public showResults = false;
    public results = [];
    public userFieldValueType;
    private presenter;

    constructor(
        @INode readonly element: INode,
        @IApiService readonly api: IApiService,
        @IEventAggregator readonly ea: IEventAggregator,
        @INotification readonly notification: INotification,
        @newInstanceForScope(IValidationController)
        readonly controller: IValidationController,
        @IValidationRules readonly validationRules: IValidationRules
    ) {
        this.presenter = new FieldValidationRenderer();
        this.controller.addSubscriber(this.presenter);

        validationRules
            .on(this)
            .ensure((m) => m.userFieldValue)
            .satisfiesRule(new AbnSelectedPropertyRule('userFieldValue'))
            .withMessage('')
            .satisfiesRule(new AbnNumberSelectedPropertyRule('userFieldValue'))
            .withMessage('')
            .satisfiesRule(new AbnNameSelectedPropertyRule('userFieldValue'))
            .withMessage('');
    }

    @watch('userFieldValue')
    userFieldValueChanged(newVal) {
        const isNumber = Number(newVal.trim());

        if (newVal.length > 5) {
            this.buttonDisabled = false;
        } else {
            this.buttonDisabled = true;
            this.clear();
        }

        if (newVal) {
            this.userFieldValueType = !isNaN(isNumber) ? 'number' : 'string';
        }
    }

    private handleKeyPress(event: KeyboardEvent) {
        if (event.key === 'Enter' && !this.buttonDisabled) {
            this.doSearch();
        }

        return true;
    }

    doSearch() {
        this.clear();
        this.buttonDisabled = true;
        this.showSearch = true;

        // check if search value has been entered with abn formatting: 99 999 999 999
        const isNumber = Number(this.userFieldValue.replace(/ /g, ''));
        let searchValue = this.userFieldValue;
        if (isNumber > 0) {
            // remove spaces from abn formatted number
            searchValue = this.userFieldValue.replace(/ /g, '');
        }

        this.api
            .getAbn(searchValue)
            .then((response) => {
                if (response.length) {
                    this.results = response;
                    this.showResults = true;
                    this.buttonDisabled = false;
                    this.showSearch = false;
                    this.selectedResult = null;

                    // preselect if only one row is returned
                    if (response.length === 1) {
                        this.selectAbn(response[0]);
                    }
                } else {
                    this.notification.error(
                        'No results found, please try again.',
                        {
                            timeout: 5000,
                        }
                    );
                    this.showResults = false;
                    this.buttonDisabled = false;
                    this.showSearch = false;
                    this.selectedResult = null;
                }
            })
            .catch((e) => {
                this.notification.error(e.message, { timeout: 5000 });
                this.error = e;
                this.showResults = false;
                this.buttonDisabled = false;
                this.showSearch = false;
                this.selectedResult = null;
            });
    }

    passedAbnChanged(obj) {
        if (objectIsValid(obj)) {
            this.manuallySelected = true;
            this.selectedResult = obj;
        }
    }

    selectAbn(result) {
        this.clear();

        this.manuallySelected = true;

        // remove search string
        this.userFieldValue = '';

        let selectedRow = result;

        // perform another search by abn number to get the entityTypeCode, entityTypeDescription and gstRegistered
        // details which are not returned by a name search
        if (selectedRow.lookupMode === 'Name') {
            this.api.getAbn(selectedRow.abn).then((response) => {
                selectedRow = response;
            });
        }

        this.selectedResult = {
            number: selectedRow.abn,
            name: selectedRow.name,
            entityTypeCode: selectedRow.entityTypeCode,
            entityTypeDescription: selectedRow.entityTypeDescription,
            gstRegistered: selectedRow.gstRegistered,
            gstExempt: false, // detail not provided by ABR web services
        };

        this.callback({
            number: selectedRow.abn,
            name: selectedRow.name,
            result: selectedRow,
            entityTypeCode: selectedRow.entityTypeCode,
            entityTypeDescription: selectedRow.entityTypeDescription,
            gstRegistered: selectedRow.gstRegistered,
            gstExempt: false, // detail not provided by ABR web services
        });

        // Validate to clear any existing errors
        this.controller.validate();

        if (this.resetOnChange) {
            this.ea.publish(`${this.stepName}QuestionsChanged`);
        }
    }

    clear() {
        this.results = [];
        this.showResults = false;
        this.error = null;
    }
}

const validateInputValueType = (val) => typeof val === 'number' && !isNaN(val);

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = AbnLookup;

    // @ts-ignore
    const proto = AbnLookup.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }